export const decodeHtmlEntity = (str) => {
  return str
    .replace(/&#(\d+);/g, function (match, dec) {
      return String.fromCharCode(dec);
    })
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
};

export function validateProductPrice(prices) {
  const discounted_percentage = prices?.discounted_percentage;
  const discounted_price = prices?.discounted_price;
  const original_price = prices?.original_price;
  const price = prices?.price;

  // Calculate discount amount if discounted_price exists
  const discount_amount = discounted_price
    ? original_price - discounted_price
    : 0;

  // Return the values in the required format
  return {
    original_price: Math.round(original_price),
    discounted_price: Math.round(discounted_price || price),
    discounted_percentage: Math.round(discounted_percentage),
    discount_amount: Math.round(discount_amount),
  };
}

export function validateProductImage(image) {
  return image?.includes('.renditions')
    ? `${process.env.NEXT_PUBLIC_IMG_BASEURL}${image
        ?.replaceAll(
          '"{{media url="',
          `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`
        )
        ?.replaceAll(`/media/" `, '/media/')
        ?.replaceAll(`.renditions`, '')
        ?.replaceAll('"}}"', '')
        ?.replaceAll('{{media url=', `${process.env.NEXT_PUBLIC_IMG_BASEURL}/`)
        ?.replaceAll('}}', '')}`
    : `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${image}`;
}

export const labelPositions = (pos) => {
  const positions = {
    0: 'left-0 top-0',
    1: 'left-1/2 -translate-x-1/2 top-0',
    2: 'right-0 top-0',
    3: 'left-0 top-1/2 -translate-y-1/2',
    4: 'left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2',
    5: 'right-0 top-1/2 -translate-y-1/2',
    6: 'left-0 bottom-0',
    7: 'left-1/2 -translate-x-1/2 bottom-0',
    8: 'right-0 bottom-0',
  };

  return positions?.[pos];
};

export const modifyCss = (style) => {
  const styleObj = style?.split(';')?.reduce((acc, curr) => {
    const [key, value] = curr?.split(':');

    const handleKey = key
      ?.trim()
      ?.replace(/-([a-z])/g, (_, letter) => letter?.toUpperCase());

    return { ...acc, [handleKey]: value?.trim() };
  }, {});

  return styleObj;
};

export const getRatingCounts = (reviews = []) => {
  if (!reviews || !reviews || !Array.isArray(reviews)) {
    return {
      totalReviews: '0',
      averageRating: '0',
    };
  }

  let totalRating = 0;
  let reviewCount = 0;

  reviews.forEach((review) => {
    if (
      review.ratings &&
      Array.isArray(review.ratings) &&
      review.ratings.length > 0
    ) {
      const ratingValue = review.ratings[0].value;

      totalRating += ratingValue;
      reviewCount++;
    }
  });

  const averageRating =
    reviewCount > 0 ? Math.round((totalRating / reviewCount) * 100) / 100 : 0;

  return {
    totalReviews: reviewCount?.toString() || '0',
    averageRating: averageRating?.toString() || '0',
  };
};

export function parseApiDate(dateStr) {
  if (!dateStr) return null;
  const date = new Date(dateStr.replace(' ', 'T'));
  return isNaN(date.getTime()) ? null : date;
}

export function isFlashSaleActive(startDate, endDate) {
  const start = parseApiDate(startDate);
  const end = parseApiDate(endDate);
  if (!end) return false;

  const now = Date.now();
  if (start && now < start.getTime()) return false;
  return now < end.getTime();
}

export function formatFlashSaleCountdown({ days, hours, minutes, seconds }) {
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
  const time = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  return days > 0 ? `${days}d ${time}` : time;
}

export function getCurrentDateTime() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');
  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDateTime;
}
